import React from "react"
import "../style/style.scss"
import "typeface-roboto"
import "typeface-racing-sans-one"
import "typeface-love-ya-like-a-sister"

export const MainLayout = ({ children }) => {
  return <main>{children}</main>
}
